
























































































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import Bar2 from '@/components/organizationDashboard/charts/Bar2.vue';
import LineBar from '@/components/organizationDashboard/charts/Line.vue';
import Chart from '@/components/organizationDashboard/charts/Chart.vue';
import CharTitleIcon from '@/components/organizationDashboard/eachProject/CharTitleIcon.vue';
import ProjectOperators from '@/components/organizationDashboard/eachProject/ProjectOperators.vue';
import CommonButton from '@/components/common/CommonButton.vue';

@Component({
  components: {
    Bar2,
    LineBar,
    Chart,
    CharTitleIcon,
    CommonButton,
    ProjectOperators,
  },
})
export default class EachProjectCard extends Vue {
  @Prop({ default: '' })
  public projectTitle!: string;

  @Prop({ default: null })
  public projects!: Array<{ title: string; src: any }>;
  private isChangedChart: boolean = true;
  private value: boolean = false;
  private commonButtonColor: string = 'cyan';

  @Emit('onSlideProjectCard')
  public getIndex(projectIndex: number): number {
    return projectIndex;
  }

  private projectAllTickets: number = 300;
  private projectAchievementTickets: number = 100;
  private projectAllTimes: number = 1000;
  private projectAchievementTimes: number = 400;

  private ticketChartLabels: string[] = ['11/1', '11/8', '11/15', '11/22', '11/29', '11/21'];
  private ticketData1: number[] = [0, 15, 40, 69, 100, 150];
  private ticketData2: number[] = [50, 95, 121, 135, 148, 150];

  private manHourChartLabels: string[] = ['5/1', '5/5', '5/9', '5/13', '5/17', '5/21', '5/25', '5/29'];
  private manHourData1: number[] = [160, 158, 155, 140, 121, 100, 99];
  private manHourData2: number[] = [160, 140, 120, 100, 80, 60, 40, 20, 0];

  // チケット数チャート用のデータ
  private ticketChartData: Chart.ChartData = {
    labels: this.ticketChartLabels,
    datasets: [
      {
        // 線の下側をどうするか
        backgroundColor: 'rgba(252, 79, 168, 0.3)',
        borderColor: 'rgba(252, 79, 168, 0.5)',
        pointBackgroundColor: 'rgba(252, 79, 168, 1)',
        data: this.ticketData1,
        fill: false,
      },
      {
        // 線の下側をどうするか
        backgroundColor: 'rgba(76, 132, 253, 0.3)',
        borderColor: 'rgba(76, 132, 253, 0.5)',
        pointBackgroundColor: 'rgba(76, 132, 253, 1)',
        data: this.ticketData2,
        fill: false,
      },
    ],
  };
  private ticketChartOptions: Chart.ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    legend: { display: false, fullWidth: false, reverse: false, rtl: false },
    tooltips: { enabled: false },
    plugins: {
      datalabels: {
        // hide datalabels for all datasets
        display: false,
      },
    },
    scales: {
      // 軸設定
      xAxes: [
        // Ｘ軸設定
        {
          scaleLabel: {
            // 軸ラベル
            display: false, // 表示設定
          },
          gridLines: {
            // 補助線
            color: 'rgba(0, 0, 0, 0)', // 補助線の色
          },
          ticks: {
            // 目盛り
            fontColor: 'rgba(0, 0, 0, 0.2)', // 目盛りの色
          },
        },
      ],
      yAxes: [
        // Ｙ軸設定
        {
          scaleLabel: {
            // 軸ラベル
            display: false, // 表示の有無
            // フォントサイズ
          },
          gridLines: {
            // 補助線
            color: 'rgba(0, 0, 0, 0.08)', // 補助線の色
          },
          ticks: {
            // 目盛り
            min: 0, // 最小値
            max: 180, // 最大値
            stepSize: 30, // 軸間隔
            fontColor: 'rgba(0, 0, 0, 0.2)', // 目盛りの色                 // フォントサイズ
          },
        },
      ],
    },
  };

  // 工数チャート用のデータ
  private manHourChartData: Chart.ChartData = {
    labels: this.manHourChartLabels,
    datasets: [
      {
        // 線の下側をどうするか
        backgroundColor: 'rgba(252, 79, 168, 0.3)',
        borderColor: 'rgba(252, 79, 168, 0.5)',
        pointBackgroundColor: 'rgba(252, 79, 168, 1)',
        data: this.manHourData1,
        fill: false,
      },
      {
        // 線の下側をどうするか
        backgroundColor: 'rgba(76, 132, 253, 0.3)',
        borderColor: 'rgba(76, 132, 253, 0.5)',
        pointBackgroundColor: 'rgba(76, 132, 253, 1)',
        data: this.manHourData2,
        fill: false,
      },
    ],
  };
  private manHourChartOptions: Chart.ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    legend: { display: false, fullWidth: false, reverse: false, rtl: false },
    tooltips: { enabled: false },
    plugins: {
      datalabels: {
        // hide datalabels for all datasets
        display: false,
      },
    },
    scales: {
      // 軸設定
      xAxes: [
        // Ｘ軸設定
        {
          scaleLabel: {
            // 軸ラベル
            display: false, // 表示設定
          },
          gridLines: {
            // 補助線
            color: 'rgba(0, 0, 0, 0)', // 補助線の色
          },
          ticks: {
            // 目盛り
            fontColor: 'rgba(0, 0, 0, 0.2)', // 目盛りの色
          },
        },
      ],
      yAxes: [
        // Ｙ軸設定
        {
          scaleLabel: {
            // 軸ラベル
            display: false, // 表示の有無
            // フォントサイズ
          },
          gridLines: {
            // 補助線
            color: 'rgba(0, 0, 0, 0.08)', // 補助線の色
          },
          ticks: {
            // 目盛り
            min: 0, // 最小値
            max: 180, // 最大値
            stepSize: 30, // 軸間隔
            fontColor: 'rgba(0, 0, 0, 0.2)', // 目盛りの色                 // フォントサイズ
          },
        },
      ],
    },
  };
}
